import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import type { UserPermissions } from "types/permissions";
import DocumentSigningActions from "./DocumentSigningActions";
import DocumentFileActions from "./DocumentFileActions";

interface DocViewerBarProps {
  isError: boolean;
  unsupportedFile: boolean;
  filename?: string;
  documentUri?: string | null;
  userPermissions: Pick<
    UserPermissions,
    "download_client_documents" | "sign_generated_document"
  > | null;
}

export default function DocViewerBar({
  isError,
  unsupportedFile,
  filename,
  documentUri,
  userPermissions,
}: DocViewerBarProps) {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const showBack = query.get("showBack") === "true";
  const showSigningActions = query.get("toolbarAction") === "sign-verify";

  return (
    <AppBar
      position="sticky"
      sx={{
        top: 0,
        display: "flex",
        width: "100%",
        alignItems: "flex-end",
        backgroundColor: "#4C505C",
        zIndex: 1000,
        height: "70px",
        gap: 5,
      }}
    >
      <Toolbar sx={{ width: "100%", gap: 3, flex: 1 }}>
        {showBack && (
          <IconButton
            color="inherit"
            size="small"
            onClick={() => history.goBack()}
            aria-label="Go back"
          >
            <ArrowLeftIcon />
          </IconButton>
        )}
        <Typography
          variant="body2"
          sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%" }}
        >
          {isError ? "" : filename || ""}
        </Typography>
        {showSigningActions && !isError && !unsupportedFile && (
          <DocumentSigningActions canSign={Boolean(userPermissions?.sign_generated_document)} />
        )}
        {!unsupportedFile && userPermissions?.download_client_documents && (
          <DocumentFileActions documentUri={documentUri} filename={filename} />
        )}
      </Toolbar>
    </AppBar>
  );
}
